const NAMES_DICTIONARY = require('./dictionary')

module.exports = (name) => !!NAMES_DICTIONARY[name.toLowerCase()]
